import React from 'react';
import CTASection from '../components/CTASection';
import Reveal from '../components/Reveal';
import { brandValues, routeHref } from '../data/siteData';

const story = [
  ['01', 'Source with intention', 'We focus on coconut products that match buyer expectations for maturity, freshness, appearance, handling, and export suitability.'],
  ['02', 'Prepare with discipline', 'Cleaning, grading, packing, and shipment planning are treated as practical trade responsibilities, not afterthoughts.'],
  ['03', 'Communicate clearly', 'Buyers need timely answers on product fit, volume, packing, destination, documentation, and shipment milestones.']
];

const AboutPage = () => {
  return (
    <main>
      <section className="page-heading">
        <div className="container-custom">
          <Reveal>
            <p className="eyebrow-pill mb-5">About S4CoconutExports</p>
            <h1 className="page-title">A focused coconut export partner for serious international buyers.</h1>
            <p className="page-intro">
              S4CoconutExports supports importers, distributors, processors, retail networks, and food businesses with coconut sourcing conversations that are practical, transparent, and export-ready.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="page-section">
        <div className="container-custom">
          <div className="about-editorial">
            <Reveal>
              <div className="about-image-tall">
                <img src="/media/harvest-image.jpg" alt="Coconut harvest and selection activity" />
              </div>
            </Reveal>

            <div className="about-storyline">
              {story.map(([number, title, text], index) => (
                <Reveal key={title} delay={index * 100}>
                  <article className="storyline-item">
                    <span>{number}</span>
                    <div>
                      <h2>{title}</h2>
                      <p>{text}</p>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="page-section section-rule">
        <div className="container-custom">
          <div className="editorial-split">
            <Reveal>
              <div>
                <p className="eyebrow-pill mb-5">Mission & vision</p>
                <h2 className="section-title mb-5">Make coconut exporting feel clear, reliable, and buyer-ready.</h2>
                <p className="section-subtitle max-w-xl">
                  The mission is to connect quality-focused coconut sourcing with international buyers who need responsive communication, realistic supply planning, and organized export support. The vision is to build a refined Indian coconut export brand trusted for process discipline and long-term buyer relationships.
                </p>
              </div>
            </Reveal>

            <Reveal delay={120}>
              <div className="value-ledger">
                {brandValues.map((value) => (
                  <article key={value.title}>
                    <h3>{value.title}</h3>
                    <p>{value.text}</p>
                  </article>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="page-section section-rule">
        <div className="container-custom">
          <Reveal>
            <div className="quote-band">
              <p>"International coconut trade rewards discipline: stable sourcing, clean handling, responsive updates, and documentation that keeps shipments moving."</p>
              <a className="text-link mt-8" href={routeHref('/process')}>See how the process works</a>
            </div>
          </Reveal>
        </div>
      </section>

      <CTASection
        eyebrow="Buyer confidence"
        title="Build a coconut supply conversation around your market needs."
        text="Share the product format, destination, target quantity, packaging expectation, and timing so the team can respond with practical export details."
        primaryLabel="Contact S4CoconutExports"
        secondaryLabel="Explore Products"
        secondaryPath="/products"
      />
    </main>
  );
};

export default AboutPage;
